import React, {FC} from "react";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {ButtonBase} from "@material-ui/core";
import useStyles from "./styles";

type CloseSnackbarButtonProps = {
  onClick: () => void;
  title?: string;
};

const CloseSnackbarButton: FC<CloseSnackbarButtonProps> = ({
  onClick,
  title,
}) => {
  const classes = useStyles();
  return title ? (
    <ButtonBase className={classes.title} onClick={onClick}>
      {title}
    </ButtonBase>
  ) : (
    <IconButton disableFocusRipple disableRipple size="small" onClick={onClick}>
      <CloseIcon fontSize="small" htmlColor="white" />
    </IconButton>
  );
};
export default CloseSnackbarButton;
